import { Component, OnInit } from '@angular/core';
import { interval, map, Observable, of, tap } from 'rxjs';

@Component({
  selector: 'app-modal-loader',
  templateUrl: './modal-loader.component.html',
  styleUrls: ['./modal-loader.component.scss']
})
export class ModalLoaderComponent implements OnInit {
  dots$: Observable<string> = of('...');

  constructor() { }

  ngOnInit(): void {

    const mod = (i: number) => {
      if (i % 3 === 0) return 3;
      if (i % 2 === 0) return 2;
      return 1;
    }

    this.dots$ = interval(500).pipe(map(d => '.'.repeat(mod(d))));
  }

}
